import Component from 'flarum/common/Component';
export default class RankBadge extends Component {
  view() {
    const attrs = this.attrs;
    const group = attrs.group;
    const color = group.color();
    const icon = group.icon();
    const label = typeof attrs.label === 'undefined' ? group.nameSingular() : attrs.label;
    return m("div", {
      className: "RankBadge",
      style: "--badge-bg:".concat(color, ";")
    }, m("i", {
      className: icon
    }), m("span", null, label));
  }
}
flarum.reg.add('datlechin-traditional-rank-icons', 'forum/components/RankBadge', RankBadge);